import React, { FC, useState } from 'react'
import StepComponent from './StepComponent'

const SolutionCreationAPIDocumentation: FC = () => {
  const [loadState, setLoadState] = useState(true)
  return <StepComponent />
}

export default SolutionCreationAPIDocumentation
